/*
 * AOM LUXE — Our Work video (sections/aom-work-video.liquid)
 * Shows a lazy poster with a play button. The video file is attached and
 * requested only when the visitor presses play; native controls take over after.
 */
(() => {
  if (customElements.get('aom-work-video')) return;

  class AomWorkVideo extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video');
      this.button = this.querySelector('[data-aom-video-play]');
      if (!this.video || !this.button || this.bound) return;
      this.bound = true;
      this.button.addEventListener('click', () => this.play());
    }

    play() {
      const { video } = this;
      if (!video.getAttribute('src')) {
        video.poster = video.dataset.poster || '';
        video.src = this.dataset.src;
      }
      video.controls = true;
      video.hidden = false;
      this.classList.add('is-playing');

      const attempt = video.play();
      if (attempt && typeof attempt.catch === 'function') {
        // playback refused (e.g. data saver): the native controls stay available
        attempt.catch(() => {});
      }
      // keep keyboard users on the player now that the button is gone
      video.focus({ preventScroll: true });
    }
  }

  customElements.define('aom-work-video', AomWorkVideo);
})();
